import { render, staticRenderFns } from "./ChefView.vue?vue&type=template&id=74e1d8ea&scoped=true&"
import script from "./ChefView.vue?vue&type=script&lang=js&"
export * from "./ChefView.vue?vue&type=script&lang=js&"
import style0 from "./ChefView.vue?vue&type=style&index=0&id=74e1d8ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e1d8ea",
  null
  
)

export default component.exports